import consumer from "./consumer"

window.addEventListener("turbolinks:load", function() {
  const messages = document.getElementById('messages');
  // チャット以外のページなら終了
  if (messages == null) {
    return;
  }
  // チャット最下層に移動
  scrollBottom()
  const appRoom = consumer.subscriptions.create({channel: "RoomChannel", chat_room_id: messages.dataset.chat_room_id, user_id: messages.dataset.user_id}, {
    connected() {
      // Called when the subscription is ready for use on the server
    },

    disconnected() {
      // Called when the subscription has been terminated by the server
    },

    received(data) {
      const messages = document.getElementById('messages');
      messages.insertAdjacentHTML('beforeend', data['message']);
    },

    speak: function (message) {
      return this.perform('speak', {message: message, chat_room_id: messages.dataset.chat_room_id, user_id: messages.dataset.user_id});
    }
  });

  // Enterでメッセージ送信
  window.addEventListener("keypress", function (e) {
    if (e.keyCode == 13){
      sendMessage();
    }
  })

  // 送信ボタンでメッセージ送信
  const messageSendBtn = document.getElementById('message-send-btn');
  messageSendBtn.onclick = sendMessage;

  function sendMessage() {
    const message = document.getElementById('message');
    if (message.value !== '' && appRoom !== null) {
      appRoom.speak(message.value);
      message.value = '';
      scrollBottom()
    }
  }
  function scrollBottom() {
    $('#chats').animate({scrollTop: $('#chats').get(0).scrollHeight}, 'fast');
  }
});

